module.exports = __webpack_public_path__ + "img/addExaminationBtn.be1f20f0.png";